import { ParsedUrlQuery } from 'querystring';

export const getUprnFromQuery = (query: ParsedUrlQuery = {}) => {
    const { uprn } = query;
    return (Array.isArray(uprn) ? uprn.find((u) => !!u) : uprn) || null;
};
